import {useMutation, useQueryClient} from "@tanstack/react-query";
import {QUERY_KEYS} from "infra/libs/react-query/queryKeys";
import {DeleteFavoritePlaceServiceParams} from "../types";
import {deleteFavoritePlace} from "../services/deleteFavoritePlace";

export function useDeleteFavoritePlaceMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({cdBeneficiarioEnderecoFavorito, signal}: DeleteFavoritePlaceServiceParams) => 
      deleteFavoritePlace({cdBeneficiarioEnderecoFavorito, signal}),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: [QUERY_KEYS.HEALTH_GUIDE_FAVORITE_PLACES]});
    },
  });
}
